import React from 'react';

import overrideStyle from 'lib/overrideStyle';

const Body = overrideStyle('div')`
font-family: ${p => p.theme.fontLibrary.secondary};
font-size: 14px;
line-height: 24px;
margin: 20px 0 0 0;
overflow-y: auto;
padding: 0 35px;
`;

export default function StyledHtmlBody({ body }) {
  return <Body dangerouslySetInnerHTML={{ __html: body }} />;
}
